"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainBaseWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var CustomClaimWatcher_1 = require("./CustomClaimWatcher");
var ModalErrorWatcher_1 = require("./ModalErrorWatcher");
var NotificationPermissionWatcher_1 = require("./NotificationPermissionWatcher");
var PreviousWorkspaceIdWatcherConnected_1 = require("./PreviousWorkspaceIdWatcher/PreviousWorkspaceIdWatcherConnected");
var UnscopeUserWatcher_1 = require("./UnscopeUserWatcher");
var UpdateMessagingTokenWatcher_1 = require("./UpdateMessagingTokenWatcher");
var WorkspaceStatWatcherConnected_1 = require("./WorkspaceStatWatcher/WorkspaceStatWatcherConnected");
var WorkspaceUserWatcherConnected_1 = require("./WorkspaceUserWatcher/WorkspaceUserWatcherConnected");
var WorkspaceWatcher_1 = require("./WorkspaceWatcher");
var react_redux_1 = require("react-redux");
var getCanRead_1 = require("../../state/getters/getCanRead");
var EnableNotificationWatcher_1 = require("./EnableNotificationWatcher/EnableNotificationWatcher");
var InvalidTokenWatcher_1 = require("./InvalidTokenWatcher");
var CameraPermissionWatcher_1 = require("./CameraPermissionWatcher");
exports.MainBaseWatcher = (0, react_1.memo)(function (_a) {
    var workspaceId = _a.workspaceId, _b = _a.useWorkspaceWatcher, useWorkspaceWatcher = _b === void 0 ? true : _b, homePathname = _a.homePathname;
    var userId = (0, react_redux_1.useSelector)(function (state) {
        return state.currentUserId || '';
    });
    var canRead = (0, react_redux_1.useSelector)(function (state) {
        return (0, getCanRead_1.getCanRead)({ state: state });
    });
    var signingOut = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ((_a = state.currentUser) === null || _a === void 0 ? void 0 : _a.signingOut) || false;
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(UpdateMessagingTokenWatcher_1.UpdateMessagingTokenWatcher, null),
        react_1.default.createElement(EnableNotificationWatcher_1.EnableNotificationWatcher, null),
        react_1.default.createElement(CameraPermissionWatcher_1.CameraPermissionWatcher, null),
        react_1.default.createElement(InvalidTokenWatcher_1.InvalidTokenWatcher, null),
        react_1.default.createElement(ModalErrorWatcher_1.ModalErrorWatcher, { homePathname: homePathname }),
        react_1.default.createElement(NotificationPermissionWatcher_1.NotificationPermissionWatcher, null),
        react_1.default.createElement(PreviousWorkspaceIdWatcherConnected_1.PreviousWorkspaceIdWatcherConnected, null),
        react_1.default.createElement(CustomClaimWatcher_1.CustomClaimWatcher, null),
        !signingOut && (react_1.default.createElement(react_1.default.Fragment, null,
            useWorkspaceWatcher && react_1.default.createElement(WorkspaceWatcher_1.WorkspaceWatcher, null),
            react_1.default.createElement(UnscopeUserWatcher_1.UnscopeUserWatcher, null),
            canRead && workspaceId && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(WorkspaceStatWatcherConnected_1.WorkspaceStatWatcherConnected, { workspaceId: workspaceId }),
                userId && (react_1.default.createElement(WorkspaceUserWatcherConnected_1.WorkspaceUserWatcherConnected, { userId: userId, workspaceId: workspaceId, key: 'WorkspaceUser' + userId + workspaceId }))))))));
});
